import "./AccountLevelDialog.scss";
import { Box, IconButton, Modal, ModalDialog, OverflowContainer, Typography } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";
import AccountLevelForm from "./AccountLevelForm";

export type AccountLevelDialogProps = {
    isOpen?: boolean;
    accountLevel?: any;
    onClosing?: (propp: any) => void;
}

const AccountLevelDialog = ({
    isOpen,
    accountLevel,
    onClosing
}: AccountLevelDialogProps) => {
    const intl = useIntl();
    const isNewAccountLevel = accountLevel === undefined;
    const headerText = isNewAccountLevel ? intl.formatMessage({id: "project.accountLevel.createDialogHeader", defaultMessage: "New folder"}) : intl.formatMessage({id: "project.accountLevel.editDialogHeader", defaultMessage: "Edit folder"});
    return (
        <Modal pageScrollLock closeable={false} active={isOpen} onClosing={() => onClosing?.(undefined)}>
            <ModalDialog br={6} className="tcsp-account-level__dialog" >
                <IconButton className="tcsp-account-level__dialog-close" icon="close" onClick={() => onClosing?.(undefined)} />
                <Box mt={10} mb={5} ml={10} mr={2} container flexDirection="column" minHeightZero>
                    <Typography variant="Heading4" mb={7}>
                        {headerText}
                    </Typography>
                    <OverflowContainer fadeOut="mask" offset={10} mr={6} pt={3} pb={5} direction={"vertical"}>
                        <AccountLevelForm accountLevel={accountLevel} onFormSubmitted={(submittedAccountLevel) => onClosing?.(submittedAccountLevel)} onCancel={() => {onClosing?.(undefined)}}/>
                    </OverflowContainer>
                </Box>
            </ModalDialog>
        </Modal>
    );
}

export default AccountLevelDialog;
